// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3nviX","content":"Consent_content__12G1g","footer":"Consent_footer__YK57n"};